import { select, spawn } from 'typed-redux-saga';

import { isRoomAgentMode, selectIsTranslatorIntegration } from '../config/selectors';
import { selectIsHeadlessCustomViewportEnabled } from '../flags/selectors';

const STABILIZATION_FPS_VIEWPORT: HeadlessViewport = {
    width: 1920,
    height: 1080,
};

export function* setHeadlessViewportSaga() {
    const isHeadlessCustomViewportEnabled = yield* select(selectIsHeadlessCustomViewportEnabled);
    if (!isHeadlessCustomViewportEnabled) {
        return;
    }

    const isRoomAgent = yield* select(isRoomAgentMode);
    if (isRoomAgent && window.ROOM_AGENT_setViewport) {
        yield* spawn([window, window.ROOM_AGENT_setViewport], STABILIZATION_FPS_VIEWPORT);
        return;
    }

    const isTranslator = yield* select(selectIsTranslatorIntegration);
    if (isTranslator && window.TRANSLATOR_setViewport) {
        yield* spawn([window, window.TRANSLATOR_setViewport], STABILIZATION_FPS_VIEWPORT);
    }
}
